import type { Ref } from 'react'
import { AutocompleteRenderInputParams, TextField } from '@mui/material'

type Props = AutocompleteRenderInputParams & { inputRef: Ref<HTMLInputElement> }

export default function Input({ inputRef, ...params }: Props) {
  return (
    <TextField
      {...params}
      inputRef={inputRef}
      placeholder={`'#' for new cases, 'esc' to exit`}
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-root': { padding: 0 },
      }}
    />
  )
}
